package ld;

import ld.Types.Vec2;
import ld.Types.Direction;
import pixi.core.math.Point;

import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.extras.BitmapText;

class Util
{
	public static function TileToCoord( tile : Vec2 ) : Vec2
	{
		var TILEWIDTH = 128;
		var TILEHEIGHT = 64;


		return { 
			x: cast( tile.x*(TILEWIDTH/2) - tile.y * (TILEWIDTH/2),Int), 
			y: cast( tile.x*(TILEHEIGHT/2) + tile.y*(TILEHEIGHT/2), Int)
		};
	}

	public static function CoordToTile( coord : Point ) : Vec2
	{
		var TILEWIDTH = 128;
		var TILEHEIGHT = 64;

		return { 
				x: Math.floor( coord.x / TILEWIDTH + coord.y / TILEHEIGHT + 0.5 ) ,
				y: Math.floor( coord.y / TILEHEIGHT - coord.x / TILEWIDTH + 1.5 )
			 };
	}


	public static function MakeButton( text : String )
	{
		var c = new Container();

		var spr = new Sprite( Texture.fromImage( "assets/Small_Button_NoFrill.png" ) );
		c.addChild(spr);

		var txt = new BitmapText(text, { font: "16px khdot16" });
		txt.x = 10;
		txt.y = 8;
		c.addChild(txt);

		spr.width = txt.width + 20;
		spr.height = txt.height + 20;

		c.interactive = true;

		return c;

	}

	public static function MakeBigButton( text : String )
	{
		var c = new Container();

		var spr = new Sprite( Texture.fromImage( "assets/Large_Button.png" ) );
		c.addChild(spr);


		var txt = new BitmapText(text, { font: "16px khdot16", align: BitmapTextAlign.CENTER });
		txt.x = spr.width / 2+2;
		txt.y = 30+2;
		txt.anchor.x = 0.5;
		txt.tint = 0;
		txt.scale.x = txt.scale.y = 2;
		c.addChild(txt);
		

		var txt = new BitmapText(text, { font: "16px khdot16", align: BitmapTextAlign.CENTER });
		txt.x = spr.width / 2;
		txt.y = 30;
		txt.anchor.x = 0.5;
		c.addChild(txt);
		
	



		txt.scale.x = txt.scale.y = 2;
		//spr.scale.x = spr.scale.y = 0.5;


		c.interactive = true;

		return c;

	}

	public static function MakeSideButton( text : String )
	{
		var c = new Container();

		var spr = new Sprite( Texture.fromImage( "assets/Small_Button.png" ) );
		c.addChild(spr);

		var txt = new BitmapText(text, { font: "16px khdot16" });
		txt.x = 15;
		txt.y = 38;
		c.addChild(txt);

		spr.scale.x = spr.scale.y = 0.5;
		spr.x = 0;
		spr.y = 0;

		c.interactive = true;

		return c;

	}

	public static inline function AbsDistance( source: Vec2, target: Vec2 )
	{
		return Math.abs( source.x - target.x ) + Math.abs( source.y - target.y );
	}

	public static inline function UnfuckMapCoords( pos: Vec2 )
	{
		pos.x += 64;
		pos.y += 64;
		return pos;
	}

	public static inline function UnfuckMapAbs( pos: Vec2 )
	{
		pos.x += 64 * 128;
		pos.y += 64 * 64;
		return pos;
	}


}